
import Nebulas from "../../../assets/filled/Nebulas.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NebulasIcon({ className, dataTestid = "NebulasIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Nebulas data-testid={dataTestid} className={classes} {...rest} />
  );
}
